// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--2tQaD","form":"styles-module--form--CyIjk","terms":"styles-module--terms--2jXFt","result":"styles-module--result--1bx_K"};